import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './card-message.module.scss';
import type {CardMessageProps} from './card-message.types';
import {CardMessageType} from './card-message.types';
import {AuthTestId} from '@/test-ids/auth-test-id';

function CardMessage({message, type}: CardMessageProps): ReactElement {
  const getContainerClasses = (): string => {
    return type === CardMessageType.ERROR ? `${styles.container} ${styles.error}` : `${styles.container} ${styles.info}`;
  };

  return (
    <div className={getContainerClasses()} data-testid={AuthTestId.ERROR_BANNER}>
      <Text val={message} size={TextSize.MD} dangerouslySetInnerHTML className={styles.message} />
    </div>
  );
}

export default React.memo(CardMessage);
